async function registerServiceWorker() {
  return navigator?.serviceWorker?.register('/service-worker.js');
}

export { registerServiceWorker };
